module.exports = __webpack_public_path__ + "img/prairiedogthumb.f27980d9.gif";